var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-col',{staticClass:"home"},[_c('home-charts-scene'),_c('m-container',[_c('m-divider',{staticClass:"home__divider"})],1),_c('home-folders-scene'),_c('home-search-scene'),_c('home-filters-scene'),_c('home-table-scene')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }